import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roiFormat',
})
export class RoiFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value == null || value === '') return '';
    const numeric = Number(value.toString().replace('%', '').trim());
    if (isNaN(numeric)) return value.toString();
    return formatNumber(numeric, 'en-US', '1.2-2');
  }
}
